module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/theme-greenery-1-8a4958d51bab36e7a5f26819958c5035.webp";